module.exports = __webpack_public_path__ + "img/shine2.df5e112f.png";